/**
 * 车辆浏览记录，记录那些车辆被浏览了
 */
import React from 'react';

import { Row, Col, DatePicker, Input, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';

//商户选择
import MemberSelect from '../../crm/member/MemberSelect';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import Loading from '../../ui/Loading';

class VehicleBrowseIndex extends React.Component {

    columns = [{
        title: '车辆名称',
        dataIndex: 'vehicleName',
        width: '10%',
    }, {
        title: '商户名称',
        dataIndex: 'memberName',
        width: '10%',
    }, {
        title: '浏览用户',
        dataIndex: 'name',
        width: '10%',
    }, {
        title: '用户电话',
        dataIndex: 'tel',
        width: '10%',
    }, {
        title: '停留时间/s',
        dataIndex: 'stayTime',
        width: '10%',
    }, {
        title: '浏览时间',
        dataIndex: 'insertTime',
        width: '10%',
    }];

    state = {
        loadData: '',
        queryData: {},
        loadingVisible: false    //导出遮罩
    };

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (field, key) =>{
        let queryData = this.state.queryData;
        queryData[field] = key;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    memberSelect = (res) => {
        let queryData = this.state.queryData;
        queryData.memberCode = res;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNo = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/mallLog/browsing/vehicle/download',
            data: queryData,
            fileName: "车辆浏览记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                {/* <Input.Search
                                    placeholder="商户名称"
                                    onSearch={this.inputSearch.bind(this, "memberName")}
                                    enterButton
                                    style={{ width: '200px'}}
                                /> */}
                                 <MemberSelect placeholder="商户" mall={1} allowClear={true} onChange={this.memberSelect} style={{ width: '250px' }} />
                                <Input.Search
                                    placeholder="车辆名称"
                                    onSearch={this.inputSearch.bind(this, "vehicleName")}
                                    enterButton
                                    style={{  margin: '0 10px', width: '200px'}}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange}/>
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/mallLog/browsing/vehicle/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />
            </div>
        )
    }
}

export default VehicleBrowseIndex;